module.exports = __webpack_public_path__ + "img/red_con2.97e0f4f8.png";